<a *ngIf="bounty" class="ui fluid card" [class.ended-no-winner]="endedWithNoWinner"
  [class.fill-height]="fillHeight" [routerLink]="['/bounties/' + bounty.id]"
  [ngClass]="bounty.type" [ngStyle]="getCardStyles(bounty.type)"
  [class.link]="!!isListing">
  <div class="content">

    <div class="header">
      <span class="ui left ribbon label" [ngClass]="labelClass">
        {{ bounty.type }}
      </span>
      <span *ngIf="bounty.type === 'beatmap'">
        Beatmap Challenge
      </span>
      <span *ngIf="bounty.type !== 'beatmap'">
        {{ title }}
      </span>
    </div>
    <div class="description" [class.is-listing]="isListing">
      <div class="beatmap-link" *ngIf="bounty.type === 'beatmap'">
        {{ title }}
        <i class="star outline icon fitted" *ngIf="bounty.beatmap_difficulty"></i> {{ bounty.beatmap_difficulty }}
      </div>

      <div class="ui list">
        <div>
          <div class="item">
            <i class="yellow crosshairs icon"></i>
            Game mode: osu!{{ bounty.mode === 'osu' ? 'standard'
            :
            bounty.mode }}
          </div>
        </div>
        <div *ngIf="bounty.type === 'beatmap'">
          <div class="item" *ngIf="bounty.beatmap_goals.includes('rank1')">
            <i class="yellow crosshairs icon"></i>
            Get the #1 score on the Leaderboard
          </div>
          <div class="item" *ngIf="bounty.beatmap_goals.includes('fc')">
            <i class="yellow crosshairs icon"></i>
            Obtain a Full Combo score on this map
          </div>
          <div class="item" *ngIf="bounty.beatmap_goals.includes('misses')">
            <i class="yellow crosshairs icon"></i>
            Get {{ bounty.misses }} or fewer
            misses
          </div>
          <div class="item" *ngIf="bounty.beatmap_goals.includes('accuracy')">
            <i class="yellow crosshairs icon"></i>
            Get {{ bounty.accuracy }}% or higher accuracy
          </div>
          <div class="item" *ngIf="bounty.beatmap_goals.includes('mods')">
            <i class="yellow crosshairs icon"></i>
            You must use these mods:
            {{ getModsString(bounty) | uppercase }}
          </div>
          <div class="item" *ngIf="!bounty.beatmap_goals.includes('mods') && bounty.beatmap_goals.includes('no_difficulty_reduction')">
            <i class="yellow crosshairs icon"></i>
            No difficulty-reduction mods
          </div>
        </div>
        <div *ngIf="bounty.type === 'pp'">
          <div class="item" *ngIf="bounty.pp_type === 'single'">
            <i class="yellow crosshairs icon"></i>
            Obtain a {{ bounty.pp_amount }}pp score on any map
            to win this reward
          </div>
          <div class="item" *ngIf="bounty.pp_type === 'total'">
            <i class="yellow crosshairs icon"></i>
            Reach a total of {{ bounty.pp_amount }}pp
          </div>
        </div>
        <div *ngIf="bounty.type === 'tournament'">
          <div class="item" *ngIf="bounty.tournament_place === 1">
            <i class="yellow crosshairs icon"></i>
            Win the tournament!
          </div>
          <div class="item" *ngIf="bounty.tournament_place === 2">
            <i class="yellow crosshairs icon"></i>
            Finish the tournament in Second Place
          </div>
          <div class="item" *ngIf="bounty.tournament_place === 3">
            <i class="yellow crosshairs icon"></i>
            Finish the tournament in Third Place
          </div>
          <div class="item" *ngIf="bounty.tournament_place > 3">
            <i class="yellow crosshairs icon"></i>
            Finish the tournament in rank <b>{{
              bounty.tournament_place }}</b>
          </div>
        </div>
        <div *ngIf="bounty.custom_goal">
          <i class="yellow crosshairs icon"></i>
          {{ bounty.custom_goal }}
        </div>
      </div>
      <div class="bottom-floated-desc">
        <div>Created by:&nbsp;
          <app-user-label [user]="bounty.owner"></app-user-label>
        </div>
        <p *ngIf="bounty.winningUser || bounty.status === 'complete'">
          <span *ngIf="bounty.winningUser">
            Bounty winner: <app-user-label [user]="bounty.winningUser"></app-user-label>
          </span>
          <span *ngIf="!bounty.winningUser">
            No winner chosen
          </span>
        </p>
        <p>
          {{ bounty.completed_at ? 'Ended' : 'Ends in' }} {{
          bounty.humanReadableTimeLeft }}
          {{ bounty.completed_at ? ' ago' : '' }}
        </p>
        <p *ngIf="bounty.activeClaimsCount && !bounty.winning_claim">
          <span class="ui yellow label claims-label">{{bounty.activeClaimsCount}}
            reward claims</span>
        </p>
        <p>
          <span *ngIf="!endedWithNoWinner && bounty.status !== 'new'"
            class="ui label" [ngClass]="statusColors[bounty.status]">
            <i class="yellow trophy icon"></i>
            {{ bounty.status === 'complete' &&
            bounty.winning_claim ? 'Bounty paid' :
            bounty.status }}
          </span>
          <span *ngIf="endedWithNoWinner" class="ui brown label">
            Ended with no winner
          </span>
        </p>
      </div>
    </div>
  </div>
  <div class="extra content">
    <h5 class="ui left floated header">
      <i class="fitted money bill green alternate icon"></i>
      {{ bounty.reward / 100 | currency }}
      <div class="ui tiny teal label pool" *ngIf="bounty.payment_type === 'pool'">
        Pool
      </div>
    </h5>
    <span class="right floated like">
      <i class="thumbs up icon" (click)="likeBounty($event)"
        [class.blue]="bounty.userHasLiked"></i>
      {{ bounty.likes }}
    </span>
    <span class="right floated">
      <i class="comment icon" [class.outline]="!bounty.comments_count"></i>
      {{ bounty.comments_count }}
    </span>
  </div>
</a>
